import { Hours } from '~/components';
import React, { useMemo } from 'react';
import { theme } from '../../components/schedule';
import { GroupCell } from '../../components/schedule/cells';
import MyAllocationsTooltip from './MyAllocationsTooltip';

function AllocatedHoursSimpleCell({ cell }) {
  const { background, color } = useMemo(() => {
    switch (cell.mode) {
      case 'header':
        return {
          background: theme.cell.total.background,
          color: !cell.allocated ? theme.cell.empty.color : theme.cell.total.color,
        };

      default:
        return {
          background: !cell.allocated ? theme.cell.empty.background : theme.cell.filled.background,
          color: !cell.allocated ? theme.cell.empty.color : theme.cell.filled.color,
        };
    }
  }, [cell.mode, cell.allocated]);

  return (
    <GroupCell style={{ background, color }}>
      <MyAllocationsTooltip cell={cell}>
        <Hours value={cell.allocated} minimumFractionDigits={0} />
      </MyAllocationsTooltip>
    </GroupCell>
  );
}

export default React.memo(AllocatedHoursSimpleCell);
